import { Truck, RotateCcw, Headphones, CreditCard } from "lucide-react";

const features = [
  {
    icon: Truck,
    title: "Tracked Shipping",
    description: "Delivery in 10 business days",
  },
  {
    icon: RotateCcw,
    title: "30-Day Trial",
    description: "Satisfied or refunded, free returns",
  },
  {
    icon: Headphones,
    title: "Responsive Support",
    description: "A team at your service 7 days a week",
  },
  {
    icon: CreditCard,
    title: "Secure Payment",
    description: "100% secure transactions",
  },
];

export const ReassuranceSection = () => {
  return (
    <section className="py-10 md:py-12 bg-background border-y border-border/50">
      <div className="container-calim">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {features.map((feature, index) => (
            <div
              key={feature.title}
              className="text-center animate-fade-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="inline-flex items-center justify-center w-10 md:w-12 h-10 md:h-12 bg-secondary rounded-sm mb-3 md:mb-4">
                <feature.icon className="h-4 md:h-5 w-4 md:w-5 text-foreground" />
              </div>
              <h3 className="text-xs md:text-sm font-semibold tracking-wide uppercase mb-1">{feature.title}</h3>
              <p className="text-xs text-muted-foreground leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
